// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__ICuzs","consentsList":"PatientConsents_consentsList__2RARL","consentsListEmpty":"PatientConsents_consentsListEmpty__fIaHw"};